import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getActiveAdvisorPopup, runAdvisorPopup } from "util/advisorPopup";
import { useProspectSetupReady } from "util/prospectSetupGate";
import styles from "./style.module.scss";

const AdvisorPopup = ({ userId, onOpen }) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const setupReady = useProspectSetupReady();
  const [, setClickTick] = useState(0);
  const popup = getActiveAdvisorPopup(userId, i18n.language);
  const onProspectHome = location.pathname.startsWith("/console/sonic-prospect");

  if (!popup) return null;
  if (onProspectHome && !setupReady) return null;

  const handleClick = () => {
    runAdvisorPopup(userId, popup);
    onOpen();
    setClickTick((n) => n + 1);
  };

  return (
    <button type="button" className={styles.popup} onClick={handleClick}>
      <span className={styles.title}>{popup.title}</span>
      <span className={styles.text}>{popup.text}</span>
    </button>
  );
};

export default AdvisorPopup;
